module.exports = __webpack_public_path__ + "static/media/zero-transactions.c4bcc42b.svg";